module.exports = __webpack_public_path__ + "img/alg2.37fd2413.png";